import { render, staticRenderFns } from "./PropertyDetails.vue?vue&type=template&id=6140801c&"
import script from "./PropertyDetails.vue?vue&type=script&lang=js&"
export * from "./PropertyDetails.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6140801c')) {
      api.createRecord('6140801c', component.options)
    } else {
      api.reload('6140801c', component.options)
    }
    module.hot.accept("./PropertyDetails.vue?vue&type=template&id=6140801c&", function () {
      api.rerender('6140801c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Application/Setup/PropertyDetails.vue"
export default component.exports